import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { Observable, Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { JobsService } from 'src/app/modules/instance/services/jobs.service';
import { SchedulerSettingsComponent } from 'src/app/modules/scheduler/components/scheduler-settings/scheduler-settings.component';
import { SchedulerSettingsService } from 'src/app/modules/scheduler/services/scheduler-settings.service';
import { ITaskModel } from 'src/app/shared/interfaces/task-model.interface';
import { ISchedulerSettings } from 'src/app/modules/scheduler/interfaces/scheduler-settings.interface';
import { MatTabGroup } from '@angular/material/tabs';
import { PageEvent } from '@angular/material/paginator';
import * as _ from 'lodash';
import ISearchProcessesPaginatedParams = ZoningAPI.ISearchProcessesPaginatedParams;
import { PaginatedJobsListComponent } from '../paginated-jobs-list/paginated-jobs-list.component';

// TODO :: move functionality to PaginatedJobsListComponent
@Component({
    standalone: false,
    selector: 'app-scheduler-page',
    templateUrl: './scheduler-page.component.html',
    styleUrls: ['./scheduler-page.component.scss']
})
export class SchedulerPageComponent implements OnInit, OnDestroy {
    jobs$: Observable<ITaskModel[]>;
    archivedJobs$: Observable<ITaskModel[]>;

    @ViewChild('tabs') tabs: MatTabGroup;
    @ViewChild('activeJobs') activeJobs: PaginatedJobsListComponent;
    @ViewChild('archivedJobs') archivedJobs: PaginatedJobsListComponent;

    showSpinner: boolean;
    pageEvent: PageEvent;
    archivedPageEvent: PageEvent;

    activeJobsSearchParams: ISearchProcessesPaginatedParams;
    archivedJobsSearchParams: ISearchProcessesPaginatedParams;

    subscriptions: Subscription[] = [];

    constructor(
        protected readonly jobsService: JobsService,
        protected readonly dialog: MatDialog,
        protected readonly schedulerSettingsService: SchedulerSettingsService,
        private readonly snackBar: MatSnackBar
    ) {}

    // If tabs are not initialized then first tab will be active
    get isActiveJobsTabActive() {
        return this.tabs ? this.tabs.selectedIndex === 0 : true;
    }

    get totalActiveJobsCount() {
        return this.jobsService.totalActiveJobsCount;
    }

    get totalArchivedJobsCount() {
        return this.jobsService.totalArchivedJobsCount;
    }

    ngOnInit() {
        this.jobs$ = this.jobsService.processes;
        this.jobsService.fetchAllJobs().subscribe();
        this.archivedJobs$ = this.jobsService.archivedProcesses;
        this.jobsService.fetchAllJobs(this.archivedJobsSearchParams, true).subscribe();

        this.subscriptions.push(
            this.jobsService.archivedProcessesListChanged.subscribe(_value => {
                this.pageChanged(this.archivedPageEvent, true);
            })
        );
        this.subscriptions.push(
            this.jobsService.processesListChanged.subscribe(_value => {
                this.pageChanged(this.pageEvent);
            })
        );
    }

    ngOnDestroy() {
        this.subscriptions.forEach(subscription => subscription.unsubscribe());
    }

    openSchedulerSettings() {
        const dialogConfig = new MatDialogConfig();

        dialogConfig.autoFocus = true;
        dialogConfig.minWidth = '600px';

        const dialogRef = this.dialog.open(SchedulerSettingsComponent, dialogConfig);

        dialogRef
            .afterClosed()
            .pipe(filter(result => result))
            .subscribe((scheduleSettings: ISchedulerSettings) => {
                this.schedulerSettingsService.updateSchedulerSettings(scheduleSettings).subscribe(() => {
                    this.snackBar.open(`Scheduler Settings successfully saved`, 'OK', {
                        verticalPosition: 'top',
                        horizontalPosition: 'center',
                        duration: 3000
                    });
                });
            });
    }

    pageChanged(event: PageEvent, getArchived: boolean = false) {
        if (getArchived) {
            this.archivedPageEvent = event;
        } else {
            this.pageEvent = event;
        }

        this.fetchJobs(getArchived);
    }

    searchParamsChanged(searchParams: ISearchProcessesPaginatedParams, getArchived: boolean = false) {
        if (getArchived) {
            this.archivedJobsSearchParams = searchParams;
            this.archivedPageEvent = null;
            this.archivedJobs && this.archivedJobs.resetPagination();
        } else {
            this.activeJobsSearchParams = searchParams;
            this.pageEvent = null;
            this.activeJobs && this.activeJobs.resetPagination();
        }

        this.fetchJobs(getArchived);
    }

    fetchJobs(getArchived: boolean = false) {
        this.showSpinner = true;

        const pageEvent = getArchived ? this.archivedPageEvent : this.pageEvent;
        const searchParams = getArchived ? this.archivedJobsSearchParams : this.activeJobsSearchParams;

        this.jobsService
            .fetchAllJobs(searchParams, getArchived, _.get(pageEvent, 'pageIndex', 0) + 1, _.get(pageEvent, 'pageSize'))
            .subscribe(() => {
                this.showSpinner = false;
            });
    }
}
